import { render, staticRenderFns } from "./rolePermission.vue?vue&type=template&id=37b23038&scoped=true"
import script from "./rolePermission.vue?vue&type=script&lang=js"
export * from "./rolePermission.vue?vue&type=script&lang=js"
import style0 from "./rolePermission.vue?vue&type=style&index=0&id=37b23038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b23038",
  null
  
)

export default component.exports